// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { resetPasswordStyles } from "@insite/content-library/Widgets/ResetPassword/ResetPassword";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

resetPasswordStyles.passwordGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};
resetPasswordStyles.passwordGridContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        max-width: 525px;
                    `,
                ],
                "min",
            )}
    `,
};
resetPasswordStyles.instructionsText = {
    variant: "h5",
    css: css`
        margin-bottom: 35px;
    `,
};
resetPasswordStyles.submitGridItem = {
    width: 12,
};
resetPasswordStyles.requirementsTitle = {
    variant: "h4",
    as: "h2",
    css: css`
        margin-bottom: 25px;
    `,
};
resetPasswordStyles.submitButton = {
    css: css`
        width: 100%;
    `,
};
